<template>
	<div class="app-container">
		<el-form
			:model="searchData"
			:inline="true"
			label-width="140px"
			label-position="right"
			ref="searchData"
		>
			<el-form-item label="承运商名称" prop="partnerName">
				<el-input v-model="searchData.partnerName" placeholder="请输入" clearable></el-input>
			</el-form-item>
			<el-form-item label="组织编号" prop="partnershipId">
				<el-input v-model="searchData.partnershipId" placeholder="请输入" clearable></el-input>
			</el-form-item>
		</el-form>
		<div class="btn-group">
			<div class="row-bg">
				<el-button type="primary" size="medium" @click="addCarrierFun">添加承运商</el-button>
				<el-button type="primary" size="medium" @click="batchAddMasterFun">批量添加承运商</el-button>
				<el-button type="primary" size="medium" @click="exportTbleFun" :loading="exportFlag">导出</el-button>
			</div>
			<div class="row-bg">
				<el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
				<el-button size="medium" @click="resetForm()">重置</el-button>
			</div>
		</div>

		<el-table
			ref="checktableData"
			:data="tableData"
			v-loading="tableLoading"
			:reserve-selection="true"
			center
			height="60vh"
		>
			<el-table-column label="操作" prop="action" min-width="120">
				<template slot-scope="scope">
					<el-link type="primary" @click="rowRemoveFun(scope.row)">移除</el-link>
				</template>
			</el-table-column>
			<el-table-column label="组织编号" prop="partnershipId" min-width="140"> </el-table-column>
			<el-table-column label="承运商名称" prop="partnerName" min-width="140"> </el-table-column>
			<el-table-column label="组织类型" prop="partnershipTypeDesc" min-width="140"> </el-table-column>
			<el-table-column label="承运中旧机数量" prop="carryOldMachineNum" min-width="140"> </el-table-column>
			<el-table-column label="操作人" prop="operateName" min-width="120"> </el-table-column>
			<el-table-column label="创建时间" prop="createdDate" min-width="140"> </el-table-column>
		</el-table>
		<div class="pagination-container">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes,prev, pager, next,jumper"
				:current-page.sync="pagination.currPage"
				:page-size="pagination.pageSize"
				:page-sizes="[10, 20, 30, 50]"
				:total="total"
			>
			</el-pagination>
		</div>
		<CarrierDialog ref="carrierDialogRef" @add-success="handleSearch"></CarrierDialog>
		<ResDialog ref="resDialogRef"></ResDialog>
		<RemoveConfirmDialog ref="removeConfirmDialogRef" @confirm-remove="confirmRemoveRowFun"></RemoveConfirmDialog>

		<commonBath
      ref="batchCommonRef"
      @opera-success="handleSearch"
      :errUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/downLoadJdFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/downLoadJdTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/jd/partnerManagementBond/importJdPartnership'"
      :title="'批量添加京东承运商'"
      :uploadTitle="'导入京东承运商'"
    ></commonBath>
	</div>
</template>
<script>
import CarrierDialog from './components/CarrierDialog.vue'
import ResDialog from './components/ResDialog.vue'
import RemoveConfirmDialog from './components/RemoveConfirmDialog.vue'
import commonBath from "@/views/oldForNewService/components/commonBath.vue"
export default {
	components: {
		CarrierDialog,
		ResDialog,
		RemoveConfirmDialog,
		commonBath
	},
	data() {
		return {
			searchData: {
				partnerName: undefined,
				partnershipId: undefined
			},
			tableData: [],
			tableLoading: false,
			pagination: {
				currPage: 1,
				pageSize: 10,
			},
			total: 0,
			exportFlag: false
		}
	},
	created() {
		this.handleSearch()
	},
	methods: {
		// 查询
		handleSearch() {
			this.pagination.currPage = 1
			this.getList()
		},
		// 清空
		resetForm() {
			this.searchData = {
				partnerName: undefined,
				partnershipId: undefined,
			}
		},
		// 移除
		rowRemoveFun (rowData) {
			// console.log('====rowData', rowData)
			this.rowData = rowData
			this.$refs.removeConfirmDialogRef.opendDialog()
		},
		// 确认移除
		confirmRemoveRowFun () {
			const url = `/autoapp-default-server-recovery/api/jd/partnerManagementBond/deleteJdPartnership?partnershipIds=${[this.rowData.partnershipId]}`
			this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					this.$message.success('移除成功')
					this.handleSearch()
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 添加承运商
		addCarrierFun () {
			this.$refs.carrierDialogRef.opendDialog('add')
		},
		// 批量导入
		batchAddCarrierFun () {
			this.$refs.resDialogRef.opendDialog()
		},
		// 当前页改变
		handleSizeChange (val) {
			this.pagination.currPage = 1
			this.pagination.pageSize = val
			this.getList()
		},
		// 页码改变
		handleCurrentChange (val) {
			this.getList()
		},
		getList () {
			const url = '/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerShip'
			const params = {
				...this.searchData,
				...this.pagination
			}
			this.tableLoading = true
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					const resData = res.data || []
					const total = res.total || 0
					this.tableData = resData
					this.total = total
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
				this.tableLoading = false
			})
		},
		// 导出
		exportTbleFun () {
			this.exportFlag = true
			setTimeout(() => {
				this.exportFlag = false
			}, 1200)
			const url = "/autoapp-default-server-recovery/api/jd/partnerManagementBond/exportJdPartnerShip"
			const title = "承运商列表导出"
			const params = {
				...this.searchData,
				...this.pagination,
			}

      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
		},
		//批量添加承运商
    batchAddMasterFun() {
      this.$refs.batchCommonRef.openDialog();
    },
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg{
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}
.upload-demo{
	margin: 0 12px;
}
.btn-group {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/carrierManage.vue